import React, { useState } from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Esto funciona para cualquier deporte?',
    a: 'Sí, las bases de la psicología deportiva son universales para fútbol, tenis, natación, gimnasia o cualquier disciplina competitiva.'
  }, {
    q: '¿A qué edad es recomendable empezar?',
    a: 'Está diseñado para niños de 8 a 14 años, que es la etapa donde el pensamiento crítico y la presión social empiezan a afectar el rendimiento.'
  }, {
    q: '¿Tengo que saber de psicología para usarlo?',
    a: 'No. Está escrito en lenguaje sencillo para padres y niños, con pasos accionables que no requieren conocimientos previos.'
  }, {
    q: '¿Qué pasa si mi hijo ya quiere abandonar el deporte?',
    a: 'Esta guía es la herramienta ideal para identificar si el deseo de abandonar viene por falta de gusto o por exceso de presión mental mal manejada.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-warm-light" data-id="element-24">
      <div className="max-w-3xl mx-auto" data-id="element-25">
        <h2 className="text-4xl font-black text-center text-warm-dark mb-12" data-id="element-26">
          Preguntas Frecuentes
        </h2>

        <div className="divide-y divide-warm-dark/10" data-id="element-27">
          {faqs.map((faq, index) => <div key={index} data-id="element-28">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-29">
                <span className="font-heading font-bold text-lg text-warm-dark pr-4" data-id="element-30">
                  {faq.q}
                </span>
                <span className={`text-warm-mid text-2xl shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`} data-id="element-31">
                  +
                </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-32">
                <p className="text-warm-mid leading-relaxed" data-id="element-33">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}